import axios from 'axios'

const apiGetPublicOrganizeGroups = (params = {}) => axios.get(
	`${process.env.REACT_APP_SOCIAL_ENDPOINT}/public/groups/organize`,
	{
		params,
		timeout: 30000,
	},
)

export { apiGetPublicOrganizeGroups }
